import ApiService from "@/api";
import ListenTaskInfo from "./ListenTaskInfo";
import { nextTick } from "vue";

export default class ListenTaskInfoAdapter {
  api: ApiService;
  listenFn: ListenTaskInfo;
  constructor(value: ListenTaskInfo = null) {
    this.api = new ApiService();
    this.listenFn = new ListenTaskInfo(value);
    this.ListenAll();
  }

  ListenAll() {
    if (this.listenFn?.CreateTasksEventFn) {
      this.OnListenCreateTasksEvent(this.listenFn.CreateTasksEventFn);
    }
    if (this.listenFn?.RemoveTaskEventFn) {
      this.OnListenRemoveTasksEvent(this.listenFn.RemoveTaskEventFn);
    }
  }

  UnListenAll() {
    if (this.listenFn?.CreateTasksEventFn) {
      this.UnListenCreateTasksEvent(this.listenFn.CreateTasksEventFn);
    }
    if (this.listenFn?.RemoveTaskEventFn) {
      this.UnListenRemoveTasksEvent(this.listenFn.RemoveTaskEventFn);
    }
  }

  OnListenCreateTasksEvent(
    f: Function = () => {
      console.log("OnUpdateTaskStatusEvent");
    },
  ) {
    try {
      this.api.Main.ProjectTaskSaveService.OnCreateTaskEventEvent.on(async (data) => {
        await f(data);
      });
    } catch (e) {
      console.log(e);
    }
  }
  OnListenRemoveTasksEvent(
    f: Function = () => {
      console.log("OnUpdateTaskStatusEvent");
    },
  ) {
    try {
      this.api.Main.ProjectTaskSaveService.OnRemoveTaskEventEvent.on(async (data) => {
        await f(data);
      });
    } catch (e) {
      console.log(e);
    }
  }
  UnListenCreateTasksEvent(f: Function) {
    this.api.Main.ProjectTaskSaveService.OnCreateTaskEventEvent.removeListener(async (data) => {
      f(data);
    });
  }
  UnListenRemoveTasksEvent(f: Function) {
    this.api.Main.ProjectTaskSaveService.OnRemoveTaskEventEvent.removeListener(async (data) => {
      f(data);
    });
  }
}
